import { observer } from 'mobx-react-lite'
import { AccessRequestArticleNotification as AccessRequestArticleNotificationType } from '../../types'
import { articleOrLayerPath } from '../../utils'
import { AccessRequestNotification } from './AccessRequestNotification'
import { useModals } from 'almanac-ui/Modal'
import { ShareSheet } from 'components/ShareSheet/ShareSheet'
import { ActiveSettingsMember, RecipientsSelectorValueType } from 'types'

interface Props {
  notification: AccessRequestArticleNotificationType
  onClose: () => void
}

export const AccessRequestArticleNotification = observer(({ notification, onClose }: Props) => {
  const subject = notification.subject
  const title = `requested ${subject.requested_permission} access to a doc`
  const path = articleOrLayerPath({ notification })
  const { openModal: openNewShareModal } = useModals()

  const openShareModal = () => {
    openNewShareModal(ShareSheet, {
      file: {
        id: notification.article.key,
        type: 'article',
      },
      initialRecipients: [{ type: RecipientsSelectorValueType.User, value: subject.sender as ActiveSettingsMember }],
      initialPermission: subject.requested_permission,
    })
  }

  return (
    <AccessRequestNotification
      notification={notification}
      onClose={onClose}
      onClick={subject.permission_granted ? undefined : openShareModal}
      title={title}
      path={path}
      aria-label="Access Request Doc Notification"
    />
  )
})
